import { create } from 'zustand';

export const useBcmSettingsStore = create((set, get) => ({
    items: [],
    loading: false,
    pagination: { current: 1, pageSize: 10, total: 0 },
    error: null,

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setPagination: (pagination) => set({ pagination }),

    // Additional setters for flexibility
    setBcmSettings: (items) => set({ items }),

    clearError: () => set({ error: null }),
}));
